import React, { useState } from 'react'
import { ModalDialogContainer } from '@common/modal'
import {
  Button,
  DialogActions,
  DialogContent,
  TextField,
} from '@common/material'
import { DialogTitle, IconButton } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import { useModal } from '@common/GlobalModal'
import { localizedStrings } from '@core/strings'

type Props = {
  onImport: (questions: string) => void
}

export const TemplateQuestionBuilderImportQuestionsModal: React.FC<Props> = ({
  onImport,
}) => {
  const { hideModal } = useModal()
  const [text, setText] = useState('')

  return (
    <ModalDialogContainer>
      <DialogTitle
        variant='h5'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        sx={{ pr: 1, fontSize: 20 }}
      >
        {localizedStrings.import}
        <IconButton aria-label='close-modal' onClick={hideModal}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          multiline={true}
          rows={4}
          fullWidth={true}
          onChange={(e) => setText(e.target.value)}
        />
      </DialogContent>
      <DialogActions sx={{ pb: 2, pr: 3 }}>
        <Button
          variant='contained'
          onClick={() => {
            onImport(text)
          }}
          disabled={!text}
        >
          {localizedStrings.import}
        </Button>
      </DialogActions>
    </ModalDialogContainer>
  )
}
